<template>
  <b-row class="item-overview-container island-cards-container">
    <md-card class="island-card">
      <md-card-header><div class="md-title">{{personalDetTitle}}</div></md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item xs-size-90 md-size-45 md-small-size-90">
            <md-field :class="{ 'md-invalid': inputErrors.firstNameErr }">
              <label>First Name</label>
              <md-input v-model="tenant.firstName" required></md-input>
              <span class="md-error">{{inputErrors.firstNameErr}}</span>
            </md-field>
            <md-field :class="{ 'md-invalid': inputErrors.lastNameErr }">
              <label>Last Name</label>
              <md-input v-model="tenant.lastName" required></md-input>
              <span class="md-error">{{inputErrors.lastNameErr}}</span>
            </md-field>
            <md-field :class="{ 'md-invalid': inputErrors.idCodeErr }">
              <label>Identity Code</label>
              <md-input v-model="tenant.idCode" required></md-input>
              <span class="md-error">{{inputErrors.idCodeErr}}</span>
            </md-field>
              <p class="moow-info-txt">Date of Birth</p>
            <div class="md-layout">
              <div class="md-layout-item md-size-20">
                <md-field :class="{ 'md-invalid': inputErrors.tenantDobDayErr }">
                  <label>Day</label>
                  <md-input v-model="tenant.dobDay" type="number" required></md-input>
                  <span class="md-error">Wrong date</span>
                </md-field>
              </div>
              <div class="md-layout-item md-size-45 ml-2">
                <md-autocomplete v-model="tenant.dobMonth" :md-options="months" required :class="{ 'md-invalid': inputErrors.tenantDobMonthErr }">
                  <label>Month</label>
                  <span class="md-error">Select month</span>
                </md-autocomplete>
              </div>
              <div class="md-layout-item md-size-25 ml-2">
                <md-field :class="{ 'md-invalid': inputErrors.tenantDobYearErr }">
                  <label>Year</label>
                  <md-input v-model="tenant.dobYear" type="number" required></md-input>
                  <span class="md-error">Wrong year</span>
                </md-field>
              </div>
            </div>
          </div>

          <div class="md-layout-item md-size-45 md-small-size-90 ml-4">
            <md-field :class="{ 'md-invalid': inputErrors.emailErr }">
              <label>Email</label>
              <md-input v-model="tenant.email" :disabled="emailReadOnly"></md-input>
              <span class="md-error">{{inputErrors.emailErr}}</span>
            </md-field>
            <md-field>
              <label>Phone</label>
              <md-input v-model="tenant.phone"></md-input>
            </md-field>
            <md-field>
              <md-select v-model="tenant.gender" name="country" id="tenantGenderSelection" placeholder="Gender">
                <md-option value="female">Female</md-option>
                <md-option value="male">Male</md-option>
              </md-select>
            </md-field>
            <md-autocomplete v-model="tenant.nationality" :md-options="nationalities">
              <label>Nationality</label>
            </md-autocomplete>
          </div>
        </div>
      </md-card-content>
    </md-card>

    <md-card class="island-card half" v-if="askAdditionalDetails">
      <md-card-header><div class="md-title">Additional Details</div></md-card-header>
      <md-card-content>
          <div class="md-layout">
            <md-radio v-model="workOrStudy" value="work" class="md-primary">Working</md-radio>
            <md-radio v-model="workOrStudy" value="study" class="md-primary">Studying</md-radio>
          </div>  
          <div class="md-layout">
            <div class="md-layout-item">
              <md-field :class="{ 'md-invalid': inputErrors.tenantWorkOrStudyErr }">
                <label>Place of {{workOrStudy}}</label>
                <md-input v-if="workOrStudy" v-model="tenant.placeOfWorkOrStudy" required></md-input>
                <md-input v-else v-model="tenant.placeOfWorkOrStudy" readonly></md-input>
                <span class="md-error">Select place</span>
              </md-field>
              <md-field>
                <label>Comment</label>
                <md-input v-model="tenant.stayComment"></md-input>
              </md-field>
            </div>
          </div>
      </md-card-content>
    </md-card>

    <md-card class="island-card half">
      <md-card-header><div class="md-title">Guests</div></md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item">
            <md-field :class="{ 'md-invalid': inputErrors.nrOfGuestsComingErr }">
              <label>Nr Of Guests</label>
              <md-input v-model="nrOfGuestsLocal" type="number"></md-input>
              <span class="md-error">{{inputErrors.nrOfGuestsComingErr}}</span>
            </md-field>
            <div  v-for="(data, index) in guestNames" :key="index" class="md-layout">
              <div class="md-layout">
                <div class="md-layout-item">
                  <md-field>
                    <label>Guest name #{{data.seq+1}}</label>
                    <md-input v-model="data.name"></md-input>
                  </md-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>

  </b-row>
</template>

<script>
  // import {
  //   nationalityList,
  //   monthList
  // } from '../../lists.js'
  const lists = require("@/lists.js");

  export default {
    props: {
      tenant:{
        type: Object,
        required: true
      },
      nrOfGuestsComing:{
        type: Number,
        required: true
      },
      emailReadOnly:{
        type: Boolean,
        required: false,
        default: false
      },
      askAdditionalDetails:{
        type: Boolean,
        required: false,
        default: true
      },
      personalDetTitle:{
        type: String,
        required: false,
        default: "Your Details"
      }
    },
    components: {
    },
    data() {
      return {
        nrOfGuestsLocal: 0,
        workOrStudy: "",
        months: lists.monthList,
        nationalities: lists.nationalityList,
        inputErrors:{
          tenantDobYearErr:false,
          tenantDobMonthErr: false,
          tenantDobDayErr:false,
          nrOfGuestsComingErr:false,
          guestNamesErr: false,
          firstNameErr: false,
          lastNameErr: false,
          idCodeErr: false,
          tenantWorkOrStudyErr: false,
          emailErr: false
        },
      }
    },
    watch: {
      'tenant.placeOfWorkOrStudy': function(val, oldVal){
        if(val) this.inputErrors.tenantWorkOrStudyErr = ""
      },
      'tenant.idCode': function(val, oldVal){
        if(val) this.inputErrors.idCodeErr = ""
      },
      'tenant.email': function(val, oldVal){
        if(!val) this.inputErrors.emailErr = "Required"
        else if(!this.validateEmail(val)) this.inputErrors.emailErr = "Invalid"
        else this.inputErrors.emailErr = false
      },
      'tenant.firstName': function(val, oldVal){
        if(val) this.inputErrors.firstNameErr = ""
      },
      'tenant.lastName': function(val, oldVal){
        if(val) this.inputErrors.lastNameErr = ""
      },
      'tenant.dobDay': function (val) {
        if(val >31 || val<1) this.tenantDobDayErr = "Invalid"
        else this.inputErrors.tenantDobDayErr = false
      },
      'tenant.dobMonth': function (val) {
        if(!val) this.tenantDobMonthErr = "Required"
        else this.inputErrors.tenantDobMonthErr = false
      },
      'tenant.dobYear': function (val) {
        if(val > this.currentYear  || val < this.currentYear-90) this.inputErrors.tenantDobYearErr = true
        else this.inputErrors.tenantDobYearErr = false
      },
      nrOfGuestsComing:function(val){
        if(val <0) {
          this.inputErrors.nrOfGuestsComingErr = "Required to be positive"
        }
        else this.inputErrors.nrOfGuestsComingErr = false
      }
    },
    computed: {
      guestNames(){
        var names = []
        for (var i = 0; i < this.nrOfGuestsLocal; i++) {
          names.push({'name':'', 'seq': i})
        }
        return names;
      }
    },
    created(){
      this.currentYear = (new Date()).getFullYear()
      this.nrOfGuestsLocal = this.nrOfGuestsComing
    },
    methods: {
      getGuestNames(){
        return this.guestNames
      },
      falsifyAllErrors(){
          this.inputErrors.tenantDobDayErr=false
          this.inputErrors.tenantDobYearErr=false
          this.inputErrors.tenantWorkOrStudyErr=false
      },
      validateForm(){
        console.log("tenantForm | validateForm()")
        var result = true
        if(!this.tenant.dobYear){
          this.inputErrors.tenantDobYearErr = "Required"
          result = false
        } 
        if(!this.tenant.dobDay){
          this.inputErrors.tenantDobDayErr = "Required"
          result = false
        }
        if(!this.tenant.email || !this.validateEmail(this.tenant.email)){
          this.inputErrors.emailErr = "Required"
          result = false 
        }
        if(!this.months.includes(this.tenant.dobMonth)){
          this.inputErrors.tenantDobMonthErr = "Required"
          result = false
        }
        if(!this.tenant.lastName){
          this.inputErrors.lastNameErr = "Required"
          result = false
        }
        if(!this.tenant.firstName){
          this.inputErrors.firstNameErr = "Required"
          result = false
        }
        if(!this.tenant.idCode){
          this.inputErrors.idCodeErr = "Required"
          result = false
        }
        //mid-check
        if(!result) return false

        console.log('midway through');

        if(this.askAdditionalDetails){
          if(!this.workOrStudy){
            this.inputErrors.tenantWorkOrStudyErr=true
            result = false
          }

          if(!this.tenant.placeOfWorkOrStudy) {
            this.inputErrors.tenantWorkOrStudyErr=true
            result = false
          }
          //mid-check
          if(!result) return false
        }

        result = this.validateGuestNames()
        return result
      },
      validateGuestNames(){
        console.log('validateGuestNames');
        
        if(this.nrOfGuestsLocal==0){
          this.guestNames=[]
          return true
        }
        var res = true
        this.inputErrors.nrOfGuestsComingErr = false
        for(var i=0; i<this.guestNames.length; i++){
          if(this.guestNames[i].name == ""){
            this.inputErrors.nrOfGuestsComingErr = "All names are required"
            res=false
          } 
        }

        if(this.guestNames.length != this.nrOfGuestsLocal){
          this.inputErrors.nrOfGuestsComingErr = "All names are required"
          res=false
        }
        return res
      },
      validateEmail(checkMe){
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(checkMe);
      },
    }
  }
</script>
<style scoped>
  @import '../../assets/styles/dashboard.css';
  @import '../../assets/styles/booking.css';
  @import '../../assets/styles/global.css';
  @import '../../assets/styles/listings-view.css';

  .booking-request-content-container{
    padding: 1em;
  }

  .details-side-bar{
    border: 1px solid #cad1da;
    padding: 1.5em;
  }
</style>



// WEBPACK FOOTER //
// src/components/bookings/tenantForm.vue